import Hosts from '../../../Hosts';


const object_type = 'store/order'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/store_order_p'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        tipo_documento: 'nota_de_encomenda',
        numero: '',
        serie: '',
        data: '',                                                           // 'AAAA-MM-DD',
        timestamp: '',                                                      // 'with all info',
        documento: {
            user_info : {
                id_user: '',
                username: '',                                               // para fazer match
                name: '',
                vat: '',
                //vat: '999999990',                                         // Caso não exista é o 999999990 que é o consumidor final genérico 
                addresses: [{
                    village: '',
                    city: '',
                    type: [],
                    region: '',
                    country: '',
                    apartado: '',
                    localidade: '',
                    contats: [],
                    principal: '',
                    observation: '',
                    postal_code: '',
                    street_name: '',
                    address_detail: '',
                }],                                                         // user_data_inter
                contacts: [{
                    email: '',
                    phone: '',
                    principal: 'true',
                    extensions: [],
                    observation: '',
                    mobile_phone: '',
                    building_number: '',
                    person_responsables: [{
                        name: '',
                        email: '',
                        extensions: '',
                        observation: '',
                        mobile_phone: ''
                    }],
                }],                                                         // user_data_inter
                obs: '',
            },
            linhas:[
                // {
                //     id_produto: '',
                //     designacao: '',
                //     unidade: '',

                //     quantidade: 0.00,
                //     preco_unitario: 0.00000000, 

                //     taxa_iva: 0.00 ,
                //     taxa_desconto_linha: 0.00,

                //     total_iliquido: 0.00,                                   // preco_unitario * quantidade

                //     total_desconto: 0.00,                                   // total_iliquido * taxa_desconto_linha * 0.01
                //     total_iliquido_com_desconto: 0.00,                      // total_iliquido - total_desconto
                    
                //     total_iva: 0.00,                                        // total_iliquido_com_desconto * taxa_iva * 0.01
                //     total_com_iva: 0.00,                                    // total_iliquido_com_desconto + total_iva

                
                //     total_liquido: 0.00,                                    // total_com_iva
                // },
            ],

            // Valores do Globais do Documento
            total_iliquido_documento: 0.00,                                 // soma do total_iliquido_com_desconto de todas as linhas 
            total_desconto_linha_documento: 0.00,                           // soma do total_desconto de todas as linhas 
            taxa_desconto_global: 0,                                        // em %
            valor_desconto_global_a_aplicar: 0.00, 
            total_iliquido_documento_com_deconto_linha_e_global: 0.00,      // total_iliquido_documento - (total_desconto_linha_documento + valor_desconto_global_a_aplicar)

            total_iva_documento: 0.00,
            /* 
            let get_total_iva_documento = (linhas) => {
                
                let tmp_total_iva = 0.00
                
                foreach linha in linhas{
                    let v_tmp_iliq = linha.total_iliquido_com_desconto - linha.valor_desconto_global_a_aplicar 
                    let v_tmp_iva = v_tmp_iliq * linha.taxa_iva * 0.01
                    tmp_total_iva += v_tmp_iva
                }

                return tmp_total_iva
            }
            */

            total_documento: 0.00 //total_iliquido_documento_com_deconto_linha_e_global + total_iva_documento
        }
    }
}

export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}